<div class="col-lg-12 content-scroll-screen parent">
  <p-card class="card-spacing-0" *ngIf="fromStacker">
    <span
      class="d-flex justify-content-between align-items-center m-3 globalborder-btm-header pb-2">
      <span class="col-auto">
        <h2 class="mb-0">Order Tracking</h2>
      </span>

      <div class="justify-content-between d-flex" *ngIf="!hideAddUploadButtons">
        <div class="ms-3 nav-link d-flex align-items-center">
          <a class="link" (click)="addIpTrackingLine()">+ Add</a>
        </div>
        <div class="ms-3 nav-link d-flex align-items-center">
          <a class="link" (click)="uploadIpTrackingLine()">
            <i class="pi pi-cloud-upload icon-blue mx-1"></i> Upload</a
          >
        </div>
        <div class="ms-3 nav-link d-flex align-items-center">
          <a class="link delcol" (click)="deleteIpTrackingLine()">
            <i class="pi pi-trash delcol"></i> Delete</a
          >
        </div>
      </div>

      <div class="orders-panel col-auto d-flex justify-content-between">
        <div class="ms-3 nav-link dropdown d-flex align-items-center">
          <i class="pi pi-cloud-upload icon-blue mx-1"></i>
          <a class="link" (click)="exportExcel()">Export excel</a>
        </div>
      </div>
      <span>
        <span class="cross-border" (click)="closeModal()"
          ><i class="pi pi-times"></i
        ></span>
      </span>
    </span>
  </p-card>
  <p-table
    #dt
    stripedRows
    [value]="orderTrackingGridListing"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="orderTrackingGridListing.length > 20"
    [filterDelay]="0"
    [(selection)]="selectedTrackingLine"
    selectionMode="single"
    dataKey="PortalKey"
    editMode="row"
    [scrollable]="true"
    scrollHeight="500px"
    [size]="'small'"
    styleClass="table-listing popuptable">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th class=""></th>
        <th class="col-center"></th>
        <th class="subtotal">PO #</th>
        <th class="buyer">Bill Rec</th>
        <th class="buyer">JNIAcct</th>
        <th class="number">Ship Date</th>
        <th class="number">Deliv Date</th>
        <th class="status">Carrier</th>
        <th class="name">Tracking</th>
        <th class="jname">Weight</th>
        <th class="buyer">Sale Price</th>
        <th class="buyer" style="width: 10 rem">Ship Method</th>
        <th class="buyer">Shipper Name</th>
        <th class="inhanddate">Shipped From</th>
        <!-- <th class="inhanddate">Shipped From City</th>
        <th class="inhanddate">Shipped From State</th>
        <th class="inhanddate">Shipped From Zip</th>
        <th class="inhanddate">Shipped From Street</th> -->
        <th class="inhanddate">S-Ctry</th>
        <th class="buyer">Recipient Name</th>
        <th class="buyer">Recipient Address</th>
        <!-- <th class="inhanddate">Recipient City</th>
        <th class="inhanddate">Recipient State</th>
        <th class="inhanddate">Recipient Zip</th>
        <th class="inhanddate">Recipient Street</th> -->
        <th class="inhanddate">R-Ctry</th>
        <!-- <th class="date-time">Shipped To</th>
          <th class="subtotal">Reference Fields</th> -->
        <th class="subtotal">Sales Order</th>
        <th class="subtotal">JNI Reference 2</th>
        <th class="subtotal">JNI Reference 3</th>
        <th class="subtotal">JNI Reference 4</th>
        <th class="subtotal">JNI Reference 5</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderTrackingGridListing
      let-rowIndex="rowIndex"
      let-editing="editing">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="orderTrackingGridListing"
        [pSelectableRowIndex]="rowIndex"
        [pEditableRow]="orderTrackingGridListing">
        <td>
          <div class="eddel-btn d-flex align-items-center">
            <ng-container
              *ngIf="
                !(
                  (orderTrackingGridListing.MatchStatus &&
                    orderTrackingGridListing.MatchStatus === 'Matched') ||
                  (orderTrackingGridListing.CreatedByPortal &&
                    orderTrackingGridListing.CreatedByPortal === 'No')
                )
              ">
              <p-button
                *ngIf="!editing"
                [disabled]="
                  (orderTrackingGridListing.MatchStatus &&
                    orderTrackingGridListing.MatchStatus === 'Matched') ||
                  (orderTrackingGridListing.CreatedByPortal &&
                    orderTrackingGridListing.CreatedByPortal === 'No')
                "
                pButton
                pRipple
                [rounded]="true"
                [text]="true"
                pInitEditableRow
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text" />
              <p-button
                *ngIf="editing"
                pButton
                pRipple
                [rounded]="true"
                [text]="true"
                pSaveEditableRow
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-help p-mr-2"
                (click)="onSaveRow(orderTrackingGridListing)" />
              <p-button
                *ngIf="editing"
                pButton
                pRipple
                [rounded]="true"
                [text]="true"
                pCancelEditableRow
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger" />
            </ng-container>
          </div>
        </td>
        <td class="col-center">
          <p-tableCheckbox
            [pSelectableRow]="orderTrackingGridListing"
            [value]="orderTrackingGridListing"></p-tableCheckbox>
        </td>

        <td class="subtotal">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.PurchId" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.PurchId }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td
          class="status"
          [ngClass]="{
            'highlight-sellprice':
              orderTrackingGridListing?.BillRecieved &&
              orderTrackingGridListing?.BillRecieved[0] === 'N' &&
              orderTrackingGridListing?.FreightAccount &&
              (orderTrackingGridListing?.FreightAccount === 1 ||
                orderTrackingGridListing?.FreightAccount[0] === 'Y'),
          }">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.BillRecieved"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing?.BillRecieved }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="status">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                [appendTo]="'body'"
                class="invoiceemailoptionstobody"
                [(ngModel)]="orderTrackingGridListing.FreightAccount"
                (change)="trackingChanged(orderTrackingGridListing)"
                [options]="booleanChoice"
                optionValue="value"
                optionLabel="enum">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing?.FreightAccount }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="number">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <!-- <p-calendar
                  jniAutoCompleteBlocker
                  inputId="basic"
                  class="date-input"
                  (onSelect)="onShipDateSelection($event)"
                  [(ngModel)]="orderTrackingGridListing.ShipDate"
                  [minDate]="shipDateCurrentdate"
                  [showOtherMonths]="true"
                  [selectOtherMonths]="true"
                  [ngModelOptions]="{ standalone: true }"
                  appendTo="body"
                ></p-calendar> -->
              <p-datePicker
                jniAutoCompleteBlocker
                [appendTo]="'body'"
                name="ShipDate"
                id="ShipDate"
                class="date-input"
                type="date"
                [(ngModel)]="orderTrackingGridListing.ShipDate"
                [minDate]="shipDateCurrentdate"
                (onSelect)="shipDateChange($event, orderTrackingGridListing)" />
            </ng-template>
            <ng-template pTemplate="output">
              <span
                *ngIf="orderTrackingGridListing?.ShipDate | hidedynamicsdate">
                {{ orderTrackingGridListing?.ShipDate | date: "yyyy-MM-dd" }}
              </span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="number">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <!-- <p-calendar
                  jniAutoCompleteBlocker
                  inputId="basic"
                  class="date-input"
                  (onSelect)="onShipDateSelection($event)"
                  [(ngModel)]="orderTrackingGridListing.DeliveryDate"
                  [minDate]="orderTrackingGridListing.ShipDate"
                  [showOtherMonths]="true"
                  [selectOtherMonths]="true"
                  [ngModelOptions]="{ standalone: true }"
                  appendTo="body"
                ></p-calendar> -->
              <p-datePicker
                jniAutoCompleteBlocker
                [appendTo]="'body'"
                name="DeliveryDate"
                id="DeliveryDate"
                class="date-input"
                type="date"
                [(ngModel)]="orderTrackingGridListing.DeliveryDate"
                [minDate]="orderTrackingGridListing.ShipDate" />
            </ng-template>
            <ng-template pTemplate="output">
              <span
                *ngIf="
                  orderTrackingGridListing?.DeliveryDate | hidedynamicsdate
                ">
                {{
                  orderTrackingGridListing?.DeliveryDate | date: "yyyy-MM-dd"
                }}
              </span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="status">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                id="currency"
                [appendTo]="'body'"
                class=""
                [(ngModel)]="orderTrackingGridListing.Carrier"
                [options]="carriers"
                optionLabel="name"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                [placeholder]="'Select Carrier'">
                <ng-template #customCarrierTemplate let-carrier>
                  <span *ngIf="carrier.name !== 'All'">{{ carrier.name }}</span>
                </ng-template>
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{
                orderTrackingGridListing.Carrier === "All"
                  ? ""
                  : orderTrackingGridListing.Carrier
              }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="name">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                [ngModelOptions]="{ standalone: true }"
                type="text"
                [(ngModel)]="orderTrackingGridListing.TrackingNumber"
                [disabled]="
                  orderTrackingGridListing?.FreightNumber !== '' &&
                  orderTrackingGridListing?.FreightNumber !== undefined
                "
                required />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                class="link"
                (click)="
                  onTrackingNumberSelection(
                    orderTrackingGridListing?.TrackingNumber
                  )
                ">
                {{ orderTrackingGridListing?.TrackingNumber }}
              </a>
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="jname">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.Weight" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.Weight | number: "1.2-2" }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="buyer">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.SellPrice"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              <span *ngIf="orderTrackingGridListing.SellPrice">
                {{
                  orderTrackingGridListing.SellPrice
                    | currency: "USD" : "symbol" : "0.2-2"
                }}
              </span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate" style="width: 300px">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                [appendTo]="'body'"
                class=""
                id="currency"
                [(ngModel)]="orderTrackingGridListing.DlvModeId"
                optionValue="modeDescriptionD365"
                optionLabel="modeDescriptionD365"
                [options]="shippingProductsList">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.DlvModeDescription }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperName" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperName }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipFromAddress"
                style="width: 100%"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipFromAddress }}
            </ng-template>
          </p-cellEditor>
        </td>
        <!-- <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperCity"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperCity }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperState"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperState }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperZipCode"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperZipCode }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperStreet"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperStreet }}
            </ng-template>
          </p-cellEditor>
        </td> -->
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipperCountry"
                style="width: 100%" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipperCountry }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientName" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientName }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.ShipToAddress"
                style="width: 100%"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.ShipToAddress }}
            </ng-template>
          </p-cellEditor>
        </td>
        <!-- <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientCity"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientCity }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientState"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientState }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientZipCode"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientZipCode }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientStreet"
                style="width: 100%"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientStreet }}
            </ng-template>
          </p-cellEditor>
        </td> -->
        <td class="inhandate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.RecipientCountry"
                style="width: 100%" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.RecipientCountry }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="date-time">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.SalesId"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.SalesId }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.JNIReference2"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.JNIReference2 }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.JNIReference3"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.JNIReference3 }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.JNIReference4"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.JNIReference4 }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderTrackingGridListing.JNIReference5"
                disabled />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderTrackingGridListing.JNIReference5 }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No order tracking found.</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <span class="text-center d-flex justify-content-center mt-3">{{
            totalSalePrice | currency: "USD"
          }}</span>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-modal-stacker
  *ngIf="orderTrackingDisplayModal"
  [displayModal]="orderTrackingDisplayModal"
  (closeEvent)="closeModalFromOrderTracking()">
  <h1 class="panelHeading">Freight Details</h1>
  <div class="panelBody">
    <jni-freight-details
      [isModal]="true"
      [trackingNumber]="trackingNumber"
      (closeEvent)="closeModalFromOrderTracking()"></jni-freight-details>
  </div>
</jni-modal-stacker>

<p-dialog
  [(visible)]="showUploadExcel"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  [closable]="false"
  styleClass="order-dialog"
  appendTo="body">
  <jni-order-tracking-excel
    (closeEvent)="closeUploadIpTrackingLine()"
    (excelData)="excelData($event)"
    (downloadExcelTemplateEvent)="
      getFreightTrackingExcelTemplate()
    "></jni-order-tracking-excel>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <p-button
        label="Cancel"
        variant="outlined"
        severity="secondary"
        (click)="closeModalDialog()" />
    </div>
  </ng-template>
</p-dialog>
